import {Injectable, Injector} from '@angular/core';
import {ApiResponse, BaseApiService} from '../base-api.service';
import {CommunicationModelService} from '../../Models/Communication/communication-model.service';
import {CommunicationFilters} from '../../../Models/Communication/communication-filters.model';
import {BreakdownsTypesModelService} from '../../Models/Communication/breakdowns-types-model.service';
import {BreakdownsPrioritiesService} from '../../Models/Communication/breakdowns-priorities.service';
import {CommunicationStoreForm} from '../../../Models/Communication/communication-store.model';
import {CommunicationTypesEnum} from '../../../Shared/Enum/communication-types.enum';
import {CommunicationTypeDto} from '../../../Models/Communication/communication-type.interface';
import {PermissionsManagerService} from '../../Shared/permissions-manager.service';
import {NoticeFamiliesModelService} from '../../Models/Communication/notice-families-model.service';

@Injectable({
  providedIn: 'root'
})
export class CommunicationApiService extends BaseApiService {

  constructor(
    protected override injector: Injector,
    protected permissionsManager: PermissionsManagerService,
    public model: CommunicationModelService,
    public breakdownsTypesModel: BreakdownsTypesModelService,
    public breakdownsPrioritiesModel: BreakdownsPrioritiesService,
    public noticeFamiliesModel: NoticeFamiliesModelService
  ) {
    super(injector);
  }


  /**
   * Obtener las comunicaciones
   *
   */
  public getCommunications(filters: CommunicationFilters | null, save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getTareasApp', filters).subscribe({
        next: (response) => {
          if (save) {
            this.model.save(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener el detalle de la comunicación
   *
   */
  public getCommunication(id: number): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getTarea/' + id, {}, 'get').subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Establecer una comunicación
   *
   */
  setCommunication(params: CommunicationStoreForm): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setTarea', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar imagen comunicación
   *
   */
  saveCommunicationImage(form: FormData): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('postImagenTarea', form, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Eliminar comunicación
   *
   */
  deleteCommunication(params: { id_tarea: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteTarea', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Abrir/Cerrar comunicación
   *
   */
  communicationDone(params: { id_tarea: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('doneTarea', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Marcar notificaciones leidas
   *
   */
  setReadNotifications(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setNotificacionesTareaLeidas', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Confirmar comunicación
   *
   */
  confirmCommunication(params: { id_tarea: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('confirmTarea', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener los tipos de averias
   *
   */
  public getBreakdownsTypes(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getFamiliasAverias', {}, 'get').subscribe({
        next: (response) => {

          if (save) {
            this.breakdownsTypesModel.save(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Obtener las prioridades de averias
   *
   */
  public getBreakdownsPriorities(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('getPrioridades', {}, 'get').subscribe({
        next: (response) => {

          if (save) {
            this.breakdownsPrioritiesModel.save(response.data);
          }

          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Asignar usuarios
   *
   */
  setCommunicationUsers(params: { id_tarea: number, ids_usuarios?: number[] }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setUsuariosTarea', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Enviar comentario
   *
   */
  sendComment(params: { id_tarea: number, message: string }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setMessage', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Subir documento
   *
   */
  uploadDocument(params: FormData): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('postDocument', params, 'post', true).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Eliminar documento
   *
   */
  deleteDocument(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteDocumentoTarea', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Vaciar chat
   *
   */
  emptyChat(params: { id: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('deleteComentariosTarea', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Guardar presupuesto de una alerta
   *
   */
  saveBreakdownBudget(form: FormData): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('setTaskBudget', form).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }


  /**
   * Cambiar estado del presupuesto
   *
   */
  setBudgetState(params: { id: number, estado: number }): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('changeStateTaskBudget', params).subscribe({
        next: (response) => {
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }

  /**
   * Retrieves the list of families for tasks of type communication.notice (avisos, AKA warnings)
   * @return {*}  {Promise<ApiResponse>}
   * @memberof CommunicationApiService
   */
  getNoticeFamilies(save: boolean = true): Promise<ApiResponse> {

    return new Promise((resolve, reject) => {

      return this.httpCall('tasks/communications/notices/families', {}, 'get').subscribe({
        next: (response) => {
          if (save) {
            this.noticeFamiliesModel.save(response.data);
          }
          resolve(response);
        },
        error: (err: Error) => {
          reject(err);
        }
      });

    });

  }

  /**
   * Obtener los tipos de comunicación
   *
   */
  getCommunicationTypes(permission: string): CommunicationTypeDto[] {
    const communicationTypes: CommunicationTypeDto[] = [
      {
        id: CommunicationTypesEnum.events,
        nombre: 'COMMUNICATION.EVENTS',
        permission: 'eventos',
        hasPermission: this.permissionsManager.checkPermission('eventos', permission),
      },
      {
        id: CommunicationTypesEnum.meetings,
        nombre: 'COMMUNICATION.MEETINGS',
        permission: 'reuniones',
        hasPermission: this.permissionsManager.checkPermission('reuniones', permission),
      },
      {
        id: CommunicationTypesEnum.warnings,
        nombre: 'COMMUNICATION.WARNINGS',
        permission: 'avisos',
        hasPermission: this.permissionsManager.checkPermission('avisos', permission),
      },
      {
        id: CommunicationTypesEnum.breakdowns,
        nombre: 'COMMUNICATION.BREAKDOWNS',
        permission: 'averias',
        hasPermission: this.permissionsManager.checkPermission('averias', permission),
      },
      {
        id: CommunicationTypesEnum.chats,
        nombre: 'COMMUNICATION.CHATS',
        permission: 'chats',
        hasPermission: this.permissionsManager.checkPermission('chats', permission),
      },
      {
        id: CommunicationTypesEnum.lists,
        nombre: 'COMMUNICATION.LISTS',
        permission: 'listas',
        hasPermission: this.permissionsManager.checkPermission('listas', permission),
      },
    ];

    return communicationTypes.filter((type) => type.hasPermission);
  }

}
